import { timeUtil } from '@cmg/common';

import { ParticipationSetsGridColDef, ParticipationSetsRow } from '../../types';

export type Value = ParticipationSetsRow['modifiedAt'];

export const lastUpdatedAtColDef: ParticipationSetsGridColDef = {
  headerName: 'Last Updated',
  field: 'modifiedAt',
  type: ['date'],
  filter: false,
  floatingFilter: true,
  width: 187,
  valueFormatter: ({ value }) => timeUtil.formatAsDisplayDate(value) || '',
  server: {
    sortFieldPath: 'modifiedAt',
  },
};
